import { gsap } from "gsap";

const cursor = document.querySelector('.cursor');
const swiperWrap = document.querySelector('.food-bank-slider');

if(window.innerWidth > 990) {
    if(cursor) {
        gsap.set(cursor, {
            xPercent: -50,
            yPercent: -50,
        });

        swiperWrap.addEventListener('mouseenter', () => {
            document.addEventListener('pointermove', moveCursor);

            setTimeout(() => {
                cursor.style.display = 'block';
            }, 100)
        });

        swiperWrap.addEventListener('mouseleave', () => {
            cursor.style.display = 'none';
        });

        let moveCursor = (e) => {
            gsap.to(cursor, {
                duration: 0,
                x: e.clientX,
                y: e.clientY,
            });
        }
    }
}
